import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import CmpModal from "../../Component/Common/ReuseableComponent/CmpModal";
import axios from "axios";
import { getGlobals } from "../../Configs";
import HeaderComponent from "./processComponent/HeaderComponent";
import {
  DataGridPro,
  gridRowIdsSelector,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import { ArrowForwardIos } from "@mui/icons-material";
import CustomerDetailDrawer from "./CustomerDetailDrawer";
import { getVerifyStatusStyle } from "../../Utility/Utilitys";

const breadCrumbStyle = {
  color: "#cccccc",
  fontSize: "0.8rem",
  textDecoration: "underline",
};

const VansalesCustomerSummary = () => {

  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const status = ["Pending", "Approved"];
  const [summaryData, setSummaryData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // Store full row data
  const [isPopModalDataChanged, setIsPopModalDataChanged] = useState(false);

  const baseURL = getGlobals().API_BASE_URL;

  const [filterObj, setFilterObj] = useState({
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    ).toISOString(),
    dateTo: new Date(),
    status: "Pending",
  });
  console.log(filterObj);

  const handleLoadBtn = () => {
    fLoad();
    if (vMediaQuery) {
      setOpenFilterModal(false);
    }
  };

  const handleRowClick = (params) => {
    setSelectedRow(params?.row);
    setOpen(true);
  };

  const apiRef = useGridApiRef();
   const handleExport = () => {
  apiRef.current.exportDataAsCsv({
    getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
    includeHeaders: true,
    utf8WithBom: true,
  });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  const fFilter = () => {
    setOpenFilterModal(true);
  };

  const columns = [
    { field: "TransId", headerName: "TransId", width: 60, align: "center" },
    {
      field: "TransDt",
      headerName: "Trans Date",
      width: 88,
      align: "center",
      valueFormatter: ({ value }) =>
        moment(value).format("DD/MM/YYYY") == "Invalid date"
          ? ""
          : moment(value).format("DD/MM/YYYY"),
    },

    { field: "Name", headerName: "Customer Name", minWidth: 120 },
    { field: "Contact", headerName: "Contact Person", minWidth: 120 },
    { field: "Mobile", headerName: "Mobile", width: 88 },
    { field: "Phone", headerName: "Phone", width: 88 },
    { field: "EMail", headerName: "Email", flex: 1, minWidth: 190 },
    { field: "Addr1", headerName: "Address 1", flex: 1, minWidth: 90 },
    { field: "Addr2", headerName: "Address 2", flex: 1, minWidth: 90 },
    { field: "Addr3", headerName: "Address 3", flex: 1, minWidth: 90 },
    {
      field: "IsVerified",
      headerName: "Status",
      width: 85,
      align: "center",
      renderCell: (params) => {
        const value = params.value ? "Approved" : "Pending";
        const style = getVerifyStatusStyle(value);
        return (
          <div style={{ padding: "2px 6px", borderRadius: 4, ...style }}>
            {value}
          </div>
        );
      },
    },
    {
      field: "CrLimit",
      headerName: "CR Limit",
      width: 63,
      type: "number",
      align: "center",
    },
    {
      field: "CrPrd",
      headerName: "CR Prd",
      width: 60,
      type: "number",
      align: "center",
    },
    { field: "StateName", headerName: "State", width: 90 },
    {
      field: "TRNNo",
      headerName: "TRN No",
      width: 65,
      type: "number",
      align: "center",
    },
    { field: "NameFL", headerName: "NameFL", width: 80 },
    {
      field: "BillToBill",
      headerName: "BillToBill",
      width: 70,
      align: "center",
    },
    { field: "GMLat", headerName: "Lat", width: 100, align: "left" },
    { field: "GMLong", headerName: "Lng", width: 100, align: "left" },
    {
      field: "GMAddress",
      headerName: "Google Map Address",
      flex: 1,
      minWidth: 140,
    },
    {
      field: "Google_Map_Area_ID",
      headerName: "Map Area ID",
      width: 90,
      align: "center",
    },
    { field: "Salesman", headerName: "Salesman", width: 130 },
    {
      field: "EnDt",
      headerName: "Entered On",
      width: 85,
      align: "center",
      valueFormatter: ({ value }) =>
        moment(value).format("DD/MM/YYYY") == "Invalid date"
          ? ""
          : moment(value).format("DD/MM/YYYY"),
    },

    { field: "ApByName", headerName: "Approved By", width: 130 },
    {
      field: "ApDt",
      headerName: "Approved On",
      width: 140,
      valueFormatter: (p) =>
        p.value ? new Date(p.value).toLocaleString() : "",
    },
    // The API returns base64 strings for these two:
  ];
  const fLoad = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}CRAppPromotions/SFCustomers_SUMMARY`,
        {
          FromDate: moment(filterObj.dateFrom).format("MM/DD/YYYY"),
          ToDate: moment(filterObj.dateTo).format("MM/DD/YYYY"),
          IsVerified: filterObj.status === "Approved" ? 1 : 0,
        }
      );

      if (response?.data?.recordset) {
        setSummaryData(response.data.recordset);
        loader.style.display = "none";
      }
    } catch (err) {
      console.log(err);
      loader.style.display = "none";
    }
  }
  useEffect(() => {
    fLoad();
  }, []);

  return (
    <Box sx={{ mx: 1.5 }}>
      <Box pt={vMediaQuery ? 0 : 2}>
        {vMediaQuery ? (
          <Grid container>
            <Grid item xs={6}>
              <div style={{ marginBottom: "0.8rem" }}>
                <span style={breadCrumbStyle}>Finance Management </span>{" "}
                <ArrowForwardIos color="info" style={{ marginRight: "0.5rem", fontSize: "0.8rem" }} />
                <span style={breadCrumbStyle}>Masters</span>
                <ArrowForwardIos color="info" style={{ marginRight: "0.5rem", fontSize: "0.8rem" }} />
                <span style={breadCrumbStyle}>Vansales Customer</span>
              </div>
            </Grid>
            <Grid item xs={3} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={fFilter}
              >
                Filter
              </Button>
            </Grid>
          </Grid>
        ) : (
          <>
              <div style={{ marginBottom: "0.8rem" }}>
                <span style={breadCrumbStyle}>Finance Management </span>{" "}
                <ArrowForwardIos color="info" sx={{ marginRight: "0.5rem", fontSize: "0.8rem" }} />
                <span style={breadCrumbStyle}>Masters</span>
                <ArrowForwardIos color="info" sx={{ marginRight: "0.5rem", fontSize: "0.8rem"  }} />
                <span style={breadCrumbStyle}>Vansales Customer</span>
              </div>

            <HeaderComponent
              status={status}
              filterObj={filterObj}
              setFilterObj={setFilterObj}
              handleLoadBtn={handleLoadBtn}
              setIsPopModalDataChanged={setIsPopModalDataChanged}
              handlePrint={handlePrint}
              handleExport={handleExport}
            />
          </>
        )}

        <Box
          sx={{
            mt: vMediaQuery ? 1 : 2,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            height: { xs: "75vh", sm: "60vh", md: "68vh", lg: "68vh" },
            width: "100%",
          }}
        >
          <DataGridPro
            apiRef={apiRef}
            rowHeight={30}
            headerHeight={40}
            rows={summaryData}
            getRowId={(v) => v.TransId}
            columns={columns}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },
            }}
            hideFooter
            onRowClick={handleRowClick}
          />
        </Box>

        {vMediaQuery && (
          <CmpModal
            open={openFilterModal}
            onClose={() => setOpenFilterModal(false)}
            title="Filter"
            width={"95%"}
            height={"auto"}
            component={
              <HeaderComponent
                closeModal={() => setOpenFilterModal(false)}
                status={status}
                handleLoadBtn={handleLoadBtn}
                filterObj={filterObj}
                setFilterObj={setFilterObj}
                handlePrint={handlePrint}
                handleExport={handleExport}
              />
            }
          />
        )}
      </Box>
      <CustomerDetailDrawer
        open={open}
        onClose={() => setOpen(false)}
        rowData={selectedRow}
        onSaveSuccess={fLoad}
      />
    </Box>
  );
};

export default VansalesCustomerSummary;
